import { capitalize, noop } from 'lodash';
import { useTranslation } from 'react-i18next';
import { CardContainer, EntityGroupWorkflowCard, IFlow, useAssetTypeActions } from '@diana/core';
import { Stack, Typography, CircularProgress } from '@mui/material';
import { THINGS_GROUP_PAGE_NS } from './i18n';

export interface IThingsGroupDraftCardProps {
  flow: IFlow;
  refetch: () => void;
  setProcessing: (value: boolean) => void;
}

export const ThingsGroupDraftCard = (props: IThingsGroupDraftCardProps) => {
  const { t } = useTranslation(THINGS_GROUP_PAGE_NS);
  const { flow, refetch, setProcessing } = props;

  const editActionTitle = flow.draftFlowId ? t('actions.continueEditing') : t('actions.edit');

  const { actions } = useAssetTypeActions({
    flow,
    entity: null,
    refetch,
    setProcessing,
    actions: {
      edit: { title: flow.draftFlowId ? t('actions.continueEditing') : t('actions.edit') },
      manage: { title: t('actions.manage') },
      version: { title: t('actions.showVersion') },
    },
  });

  const editAction = actions?.find((a) => a.title === editActionTitle);

  const iconValue = {
    imageUrl: flow.imageUrl,
    icon: flow?.icon?.shape ?? '',
    color: flow?.icon?.color ?? '',
  };

  return (
    <CardContainer>
      <EntityGroupWorkflowCard
        onClick={() => editAction?.onClick?.({ close: noop })}
        actions={actions}
        title={
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Typography variant="subtitle1" color="text.primary">
              {flow.displayName || capitalize(t('titles.draftAssetType'))}
            </Typography>
            {!!editAction?.loading && <CircularProgress size="1em" />}
          </Stack>
        }
        icon={iconValue}
      />
    </CardContainer>
  );
};
